import type { MeetingData } from '../../types';

import { axiosClient } from '@/lib/axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';

type ResponseData = {
  data: MeetingData;
};

type Params = {
  companyID: number;
  meetingID: number;
};

export const getMeetingDetails = async ({ companyID, meetingID }: Params): Promise<ResponseData> => {
  const { data } = await axiosClient.get<ResponseData>(`/companies/${companyID}/meetings/${meetingID}`);
  return data;
};
type QueryFnType = typeof getMeetingDetails;

type UseGetMeetingDetailsOptions = {
  companyID: number;
  meetingID: number;
  config?: QueryFunction<QueryFnType>;
};

export const useGetMeetingDetails = ({ companyID, meetingID, config }: UseGetMeetingDetailsOptions) => {
  return useQuery({
    queryKey: ['meeting-details', companyID, meetingID],
    queryFn: () => getMeetingDetails({ companyID, meetingID }),
    ...config,
    enabled: Boolean(companyID && meetingID),
  });
};
